export class SupplierExceptionModel {
  public supplierId: string;
  public supplierName: string;
  public exceptionReason: string;
  public exclusionFromDate: Date;
  public exclusionTillDate: Date;
}
